/*
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';

import { AlertComponent } from './alert.component';
import { AlertDataComponent } from './data/alert-data.component';
import { AlertDetailsComponent } from './data/alert-details/alert-details.component';
import { AlertHeaderComponent } from './data/alert-header/alert-header.component';
import { AlertResolver } from './shared/alert.resolver';
import { AlertRoutingModule } from './alert-routing.module';
import { AlertServiceService } from './shared/service/alert-service.service';
import { AlertSubHeaderComponent } from './data/alert-sub-header/alert-sub-header.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    FormsModule,
    CheckboxModule,
    OverlayPanelModule,
    AlertRoutingModule,
    TableModule
  ],
  providers: [AlertResolver, AlertServiceService],
  declarations: [AlertComponent, AlertDataComponent, AlertHeaderComponent, AlertSubHeaderComponent, AlertDetailsComponent]
})
export class AlertModule { }
